var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M16.365 12.318c-.027-2.831 2.312-4.191 2.418-4.255-1.318-1.926-3.367-2.19-4.086-2.221-1.739-.176-3.394 1.024-4.278 1.024-.884 0-2.249-.998-3.699-.972-1.902.028-3.657 1.107-4.635 2.808-1.978 3.425-.504 8.496 1.421 11.278.942 1.356 2.064 2.879 3.538 2.825 1.42-.056 1.956-.919 3.673-.919 1.718 0 2.201.919 3.699.887 1.532-.024 2.5-1.387 3.434-2.748 1.08-1.578 1.525-3.106 1.551-3.185-.033-.011-2.973-1.141-3.036-4.522z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M13.644 4.07c.782-.947 1.31-2.264 1.166-3.57-1.127.045-2.492.751-3.3 1.698-.726.84-1.362 2.18-1.19 3.464 1.257.098 2.542-.64 3.324-1.592z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/appleLogo.7dc61391d506c08e231435631e87110f.svg";
export { ForwardRef as ReactComponent };